import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ScrollToTop } from './components/utils/ScrollToTop';
import { Home } from './pages/Home';
import { WebDesign } from './pages/WebDesign';
import { ECommerce } from './pages/ECommerce';
import { WebsiteCare } from './pages/WebsiteCare';
import { Pricing } from './pages/Pricing';
import { Portfolio } from './pages/Portfolio';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { Policies } from './pages/Policies';
import { Privacy } from './pages/Privacy';
import { Cancellation } from './pages/Cancellation';
import { Terms } from './pages/Terms';
import { WebDesignService } from './pages/services/WebDesignService';
import { ECommerceService } from './pages/services/ECommerceService';
import { BrandingService } from './pages/services/BrandingService';
import { SEOService } from './pages/services/SEOService';
import { MaintenanceService } from './pages/services/MaintenanceService';
import { ContentService } from './pages/services/ContentService';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <ScrollToTop data-id="element-2" />
      <Layout data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/web-design" element={<WebDesign data-id="element-8" />} data-id="element-7" />
          <Route path="/ecommerce" element={<ECommerce data-id="element-10" />} data-id="element-9" />
          <Route path="/website-care" element={<WebsiteCare data-id="element-12" />} data-id="element-11" />
          <Route path="/pricing" element={<Pricing data-id="element-14" />} data-id="element-13" />
          <Route path="/portfolio" element={<Portfolio data-id="element-16" />} data-id="element-15" />
          <Route path="/about" element={<About data-id="element-18" />} data-id="element-17" />
          <Route path="/contact" element={<Contact data-id="element-20" />} data-id="element-19" />
          <Route path="/faq" element={<FAQ data-id="element-22" />} data-id="element-21" />
          <Route path="/policies" element={<Policies data-id="element-24" />} data-id="element-23" />
          <Route path="/privacy" element={<Privacy data-id="element-26" />} data-id="element-25" />
          <Route path="/cancellation" element={<Cancellation data-id="element-28" />} data-id="element-27" />
          <Route path="/terms" element={<Terms data-id="element-30" />} data-id="element-29" />
          <Route path="/services/web-design" element={<WebDesignService data-id="element-32" />} data-id="element-31" />
          <Route path="/services/ecommerce" element={<ECommerceService data-id="element-34" />} data-id="element-33" />
          <Route path="/services/branding" element={<BrandingService data-id="element-36" />} data-id="element-35" />
          <Route path="/services/seo" element={<SEOService data-id="element-38" />} data-id="element-37" />
          <Route path="/services/maintenance" element={<MaintenanceService data-id="element-40" />} data-id="element-39" />
          <Route path="/services/content" element={<ContentService data-id="element-42" />} data-id="element-41" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}